import { render } from "./aiDailyReq.vue?vue&type=template&id=0321a4af"
import script from "./aiDailyReq.vue?vue&type=script&lang=js"
export * from "./aiDailyReq.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__